import { render, staticRenderFns } from "./support-container.vue?vue&type=template&id=4665882e"
import script from "./support-container.vue?vue&type=script&lang=js"
export * from "./support-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4665882e')) {
      api.createRecord('4665882e', component.options)
    } else {
      api.reload('4665882e', component.options)
    }
    module.hot.accept("./support-container.vue?vue&type=template&id=4665882e", function () {
      api.rerender('4665882e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/support/components/support-container.vue"
export default component.exports